import Cookie from 'js-cookie';

import { EXP_PREF } from '../constants/constants';

export default function setExpPrefCookie(value: string) {
  Cookie.remove(EXP_PREF);
  Cookie.set(EXP_PREF, value, {
    domain: 'bloomberg.com',
    path: '/',
    sameSite: 'Lax',
    expires: 90,
  });
}

export function getExpPrefCookie() {
  return Cookie.get(EXP_PREF);
}
